import React from "react"
import {graphql} from "gatsby"
import ReactMarkdown from "react-markdown";
import {BlogLayout, Divider, StrapiLayout} from "@klear/open-site";

const {Helmet} = require("react-helmet");

const styles = require("../styles/index.module.scss");

export default ({ data }) => {
    const post = data.allStrapiProductUpdate.edges[0].node;
    const footerData = data.strapiFooter;

    return (
        <StrapiLayout footerProps={footerData} requireLogin>
            <Helmet>
                <title>{post.title}</title>
                <meta name="description" content={post.description} />
                <meta name="image" content={post.img.url} />
                <meta property="og:image" content={post.img.url} />
            </Helmet>
            <BlogLayout imageUrl={post.img.url} title={post.title} description={post.description} date={post.date} wideWidth>
                <div className={styles.embed} dangerouslySetInnerHTML={{ __html: post.embed }}/>
                <ReactMarkdown className={styles.content} source={post.content.data.content}/>
                <div className={styles.embed} dangerouslySetInnerHTML={{ __html: post.embedBottom }}/>
            </BlogLayout>
        </StrapiLayout>
    )
}
export const query = graphql`
  query($slug: String!) {
    allStrapiProductUpdate(filter: { slug: { eq: $slug } }) {
      edges {
              node {
                title
                description
                content {
                    data {
                        content
                    }
                }
                slug
                date(formatString: "MMMM Do, YYYY")
                img {
                  url
                }
                embed
              }
      }
    }
    allFile(filter: {relativePath: {eq: "defaultImage.png"}}) {
        edges {
          node {
            url
          }
        }
      }
      strapiFooter {
        columns {
          title
          links {
            text
            url
          }
        }
        backgroundShapes {
            color
            shapeId
            side
          }
      }
  }
`